import * as types from '../constants/actionTypes';
import initialState from './initialState';
import Immutable from 'seamless-immutable';
import { CATEGORY_ID, MEMBER_SEARCH_SCREEN } from '../constants/category';
import * as CONSTANTS from '../constants/constants';
import * as utils from '../functions/utils';
import filter from 'lodash.filter';
import categoryModel from '../models/category';

export default function memberSearchReducer(state = initialState.memberSearch, action) {
  switch (action.type) {
    case types.GET_USERS_MEMBER_SEARCH_SUCCESS: {
      return state.merge({
        ...action.data,
        isLoadingMatching: false,
        fetchingSearch: false,
        memberViewProfile:
          !utils.phoneDetect() && state.filters.isCarouselView && action.data.users.length > 0 ? action.data.users[0] : null,
        isHasMore: action.data && action.data.moreResults,
        error: {
          isError: false,
          message: '',
          timeRetry: 0,
          isShowNoConnection: false,
        },
        isGetData: true,
        isShowExpandSearch: action.data && action.data.users && action.data.users.length === 0,
        isLoading: false,
      });
    }
    case types.GET_USERS_SPOTLIGHT_SUCCESS: {
      return state.merge({
        usersSpotlight: action.data.pageNumber === 1 ? action.data.data : [...state.usersSpotlight, ...action.data.data],
        isLoadingSpotlightMember: false,
        searchGuidSpotlight: action.data.searchGuidSpotlight,
        hasMoreSpotlight: action.data.hasMoreSpotlight,
      });
    }
    case types.RESET_DISCOVERY_ERROR_STATUS: {
      return state.merge({
        error: {
          isError: false,
          message: '',
          timeRetry: 0,
          isShowNoConnection: false,
        },
      });
    }

    case types.POST_USERS_MEMBER_SEARCH_SUCCESS: {
      let updateParams = {};
      if (action.isSearchUserName) {
        updateParams = {
          isLoadingSearchUserName: false,
          isLoadingMoreSearchUserName: false,
          ...action.data,
          lastQueryFilters: action.params,
          isHasMoreSearchUserName: action.data && action.data.usersSearchUserName && action.data.usersSearchUserName.length > 0,
          error: {
            isError: false,
            message: '',
            timeRetry: 0,
            isShowNoConnection: false,
          },
        };
      } else {
        let currFilter = state.filters;
        let currFiltersKey = 'filters';
        if (action.isSearchSpotlight) {
          currFilter = state.filtersSpotlight;
          currFiltersKey = 'filtersSpotlight';
        }
        if (state.filters.orderByType && action.params) {
          const currentTab = state.filters.orderByType.filter(item => item.isCheck);
          if (
            currentTab[0].value.toLowerCase() === action.params.Type.toLowerCase() ||
            currentTab[0].value.toLowerCase() === action.params.OrderByType.toLowerCase()
          ) {
            const upLocation = { ...currFilter.location };
            if (action.data.locationName && action.data.locationName !== '') {
              upLocation.StateName = action.data.locationName;
            }
            updateParams = {
              isLoading: false,
              fetchingFiltersSearch: false,
              isLoadingMore: false,
              ...action.data,
              lastQueryFilters: action.params,
              // isShowExpandSearch: action.data && action.data.users && action.data.users.length === 0,
              // isHasMore: action.data && action.data.users && action.data.users.length > 0,
              isShowExpandSearch: action.data && action.data.users && action.data.users.length < action.data.pageSize,
              isHasMore: action.data && action.data.users && action.data.users.length === action.data.pageSize,
              memberViewProfile:
                !utils.phoneDetect() && state.filters.isCarouselView && action.data.users.length > 0 ? action.data.users[0] : null,
              error: {
                isError: false,
                message: '',
                timeRetry: 0,
                isShowNoConnection: false,
              },
              [currFiltersKey]: {
                ...state[currFiltersKey],
                location: upLocation,
              },
            };
          }

          switch (currentTab[0].id) {
            case MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.NEAR_BY:
              updateParams.isLoadingNearby = false;
              break;
            case MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.MEMBER_LEVEL:
              updateParams.isLoadingAll = false;
              break;
            case MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.MATCHING:
              updateParams.isLoadingMatching = false;
              break;
            case MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.NEWEST:
              updateParams.isLoadingNew = false;
              break;
            case MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.ACTIVE:
              updateParams.isLoadingActive = false;
              break;
            case MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.TRAVELLING:
              updateParams.isLoadingTravel = false;
              break;
            case MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.ACTIVE_NOW:
              updateParams.isLoadingActiveNow = false;
              break;
            case MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.SPOT_LIGHT:
              updateParams.isLoadingSpotlightMember = false;
              break;
            default:
              break;
          }
        }
      }
      return state.merge({ ...updateParams });
    }

    case types.UPDATE_STATE_MEMBER_SEARCH: {
      state = state.setIn([...action.dataKey], action.data);
      return state;
    }

    case types.GET_USER_SEARCH_SETTINGS_SUCCESS: {
      const { filters, userSearchSettings, showMeMemberType, lookingFor, filtersSpotlight } = Immutable.asMutable(state);
      const { data } = action;
      // console.log(action)

      //  console.log('here')
      let memberType = showMeMemberType.contentTabs[0].data;
      let lookingForType = lookingFor.contentTabs[0].data;
      // console.log(lookingFor)
      if (data.filters.memberType) {
        const powArr = utils.decimalToBinary(data.filters.memberType);
        memberType = memberType.map((item, index) => {
          const idx = powArr ? powArr.indexOf(item.id) : -1;
          if (idx !== -1) {
            return { ...item, active: true };
          }
          return { ...item, active: false };
        });
      }
      if (data.filters.seekingMemberType) {
        const powArr = utils.decimalToBinary(data.filters.seekingMemberType);
        lookingForType = lookingForType.map((item, index) => {
          const idx = powArr ? powArr.indexOf(item.id) : -1;
          if (idx !== -1) {
            return { ...item, active: true };
          }
          return { ...item, active: false };
        });
      }
      return state.merge({
        filters: {
          ...filters,
          ...data.filters,
        },
        filtersSpotlight: {
          ...filtersSpotlight,
          ...data.filters,
        },
        showMeMemberType: {
          contentTabs: [
            {
              data: memberType,
            },
          ],
        },
        showMeMemberTypeDefault: {
          contentTabs: [
            {
              data: memberType,
            },
          ],
        },

        lookingFor: {
          contentTabs: [
            {
              data: lookingForType,
            },
          ],
        },
        lookingForDefault: {
          contentTabs: [
            {
              data: lookingForType,
            },
          ],
        },
        userSearchSettings: {
          ...userSearchSettings,
          ...data.filters,
        },
        isGetUserSearchSetting: true,
      });
    }

    case types.GET_NICHE_SEARCH_SUCCESS: {
      const popularNiches = action.data
        .filter(item => item.type === 'Popular')
        .map(item => ({
          value: item,
          leftText: item.name,
        }));
      const travelDestinations = action.data
        .filter(item => item.type === 'Travel')
        .map(item => ({
          value: item,
          leftText: item.name,
        }));
      return state.merge({ popularNiches, travelDestinations });
    }

    case types.GET_LIST_ENTITIES_SUCCESS: {
      const { categoryId, data, params } = action;
      let t = data.items;
      // @override Mapping Default values for membertype && looking for data if this api done after api get userSearch Settings
      if (categoryId === CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE) {
        const { userSearchSettings } = Immutable.asMutable(state);
        if (userSearchSettings.memberType) {
          const powArr = utils.decimalToBinary(userSearchSettings.memberType);
          t = t.map(item => {
            const idx = powArr ? powArr.indexOf(item.id) : -1;
            if (idx !== -1) {
              return { ...item, active: true };
            }
            return { ...item, active: false };
          });
        }
      }
      if (categoryId === CATEGORY_ID.LTM_LOOKING_FOR && params.from === 'Discovery') {
        const { userSearchSettings } = Immutable.asMutable(state);
        if (userSearchSettings.seekingMemberType) {
          const powArr = utils.decimalToBinary(userSearchSettings.seekingMemberType);
          t = t.map(item => {
            const idx = powArr ? powArr.indexOf(item.id) : -1;
            if (idx !== -1) {
              return { ...item, active: true };
            }
            return { ...item, active: false };
          });
        }
      }
      if (params.from === 'Discovery') {
        state = state.setIn([categoryId, 'contentTabs', '0', 'data'], t).setIn([`${categoryId}Default`, 'contentTabs', '0', 'data'], t);
        if (categoryId === CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE) {
          state = state
            .setIn(['filtersSpotlight', categoryId, 'contentTabs', '0', 'data'], t)
            .setIn(['filtersSpotlight', `${categoryId}Default`, 'contentTabs', '0', 'data'], t);
        }
      }
      return state;
    }

    case types.SET_STATE_ENTITIES_TAB_INDEX: {
      const { categoryId, index, flag } = action;

      if (index !== undefined) {
        state = state.setIn([categoryId, 'contentTabs', 0, 'data', index, 'active'], flag);
      } else {
        const newState = Immutable.asMutable(state);
        newState[categoryId].contentTabs[0].data.forEach((item, subIndex) => {
          if (subIndex === 0 && categoryId !== CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE) {
            state = state.setIn([categoryId, 'contentTabs', 0, 'data', subIndex, 'active'], true);
          } else if (item.active !== flag) {
            state = state.setIn([categoryId, 'contentTabs', 0, 'data', subIndex, 'active'], flag);
          }
        });
      }
      state = state.setIn([categoryId, 'isSelecting'], flag);
      state = state.setIn([categoryId, 'isSelected'], flag);
      return state;
    }

    case types.LOAD_MORE_USERS_MEMBER_SEARCH_SUCCESS: {
      let { users, pageSize } = Immutable.asMutable(state);
      const { searchGuid } = Immutable.asMutable(state);
      const newUser = action.data && action.data.users ? action.data.users : action.data;
      const newSearchGuid = action.data && action.data.searchGuid ? action.data.searchGuid : searchGuid;
      users = [...users, ...newUser];
      return state.merge({
        users,
        searchGuid: newSearchGuid,
        pageNumber: action.params.page,
        isLoadingMore: false,
        fetchingLoadMore: false,
        isShowExpandSearch: newUser.length < pageSize,
        isHasMore: action.data.moreResults,
        error: {
          isError: false,
          message: '',
          timeRetry: 0,
          isShowNoConnection: false,
        },
      });
    }
    case types.UPDATE_SORT_ORDER_TYPE: {
      const { filters } = Immutable.asMutable(state);
      // let checkedItem = filters.orderByType.filter(item => item.isCheck);
      const orderByTypen = filters.orderByType.map((item, index) => {
        if (action.id === item.id) {
          return { ...item, isCheck: true };
        }
        return { ...item, isCheck: false };
      });
      // state = state.merge({hasChange: true});
      return state.setIn(['filters', 'orderByType'], orderByTypen);
    }

    case types.MS_UPDATE_MEMBER_SEARCH: {
      // console.log(action)
      return state.merge({ ...action.data });
    }
    case types.SET_IN_USER_MEMBER_SEARCH: {
      return state.setIn(['users', action.index], {
        ...action.user,
        profileIntersection: {
          ...action.user.profileIntersection,
          ...action.data,
        },
      });
    }
    case types.POST_USERS_MEMBER_SEARCH_ACTION_SUCCESS:
    case types.POST_USERS_MEMBER_PROFILE_ACTION_SUCCESS: {
      const { LIKE, IGNORE, UNLIKE, FAVORITE } = MEMBER_SEARCH_SCREEN.ACTION_TYPE;
      let { users } = Immutable.asMutable(state);
      const { memberViewProfile, memberViewProfiles, usersSortSpotlight } = Immutable.asMutable(state);
      let listHistory = [];
      let updateObject = {};
      const isExistsUserInListUser = users.findIndex(itm => itm.detail.userId === action.user.detail.userId);
      const isExistsUserInSpotlight = usersSortSpotlight?.findIndex(itm => itm.detail.userId === action.user.detail.userId);
      if (memberViewProfiles) {
        listHistory = memberViewProfiles.histories;
      }
      switch (action.actionType) {
        case IGNORE: {
          if (isExistsUserInListUser !== -1) {
            users = users.filter((item, index) => index !== action.index);
          }
          if (listHistory && listHistory.length > 0) {
            listHistory = filter(listHistory, (item, index) => index !== action.index);
          } else {
            listHistory = filter(listHistory, (item, index) => index !== (listHistory.length > 2 ? 1 : 0));
          }
          if (usersSortSpotlight?.length > 0) {
            state = state.merge({ usersSortSpotlight: usersSortSpotlight.filter((itm, idx) => idx !== isExistsUserInSpotlight) });
          }
          return state.merge({
            users,
            ...updateObject,
            memberViewProfiles: { ...memberViewProfiles, histories: listHistory },
          });
        }
        case LIKE:
        case UNLIKE:
          if (action.actionSuccess) {
            if (action.actionType === LIKE) {
              updateObject = {
                isFavorited: action.params.Type === FAVORITE,
                isFavoritedMutual: action.isFavouritedMutualMatch,
                isLiked: true,
                isLikedMutual: action.isFavouritedMutualMatch ? action.isFavouritedMutualMatch : action.isLikedMutualMatch,
              };
            } else if (action.actionType === UNLIKE) {
              if (action.params.Type === FAVORITE) {
                updateObject = {
                  ...action.user.profileIntersection,
                  isFavorited: false,
                  isFavoritedMutual: false,
                };
                if (action.params.isOnlyFavourite !== undefined && !action.params.isOnlyFavourite) {
                  updateObject.isLiked = false;
                  updateObject.isLikedMutual = false;
                }
              } else {
                updateObject = {
                  ...action.user.profileIntersection,
                  isLiked: false,
                  isLikedMutual: false,
                };
              }
            }
          }
          break;
        default:
          break;
      }

      if (isExistsUserInListUser > -1) {
        state = state.setIn(['users', isExistsUserInListUser], {
          ...action.user,
          profileIntersection: {
            ...action.user.profileIntersection,
            ...updateObject,
          },
        });
      }
      if (isExistsUserInSpotlight > -1) {
        state = state.setIn(['usersSortSpotlight', isExistsUserInSpotlight], {
          ...action.user,
          profileIntersection: {
            ...action.user.profileIntersection,
            ...updateObject,
          },
        });
      }
      if (action.index || action.index === 0) {
        if (listHistory !== null && listHistory.length > 0) {
          state = state.setIn(['memberViewProfiles', 'histories', action.index], {
            ...action.user,
            profileIntersection: {
              ...action.user.profileIntersection,
              ...updateObject,
            },
          });
        } else {
          state = state.setIn(['memberViewProfiles', 'histories', listHistory.length > 2 ? 1 : 0], {
            ...action.user,
            profileIntersection: {
              ...action.user.profileIntersection,
              ...updateObject,
            },
          });
        }
      }
      if (memberViewProfile) {
        state = state.setIn(['memberViewProfile', 'profileIntersection'], {
          ...updateObject,
        });
      }
      return state;
    }
    case types.API_ERROR_SEARCH: {
      const { timeRetry } = state.error;
      const updateParams = {
        isLoading: false,
        isLoadingMore: false,
        error: {
          isError: true,
          message: action.message,
          timeRetry: timeRetry + 1,
          isShowNoConnection: timeRetry >= 7,
        },
      };
      return state.merge({ ...updateParams });
    }
    case types.USER_LOGOUT_SUCCESS: {
      const reset = {
        usersSortSpotlight: [],
        usersSpotlight: [],
        error: {
          isError: false,
          message: '',
          timeRetry: 0,
          isShowNoConnection: false,
        },
        fetchingSearch: false,
        fetchingLoadMore: false,
        fetchingFiltersSearch: false,
        isGetUserSearchSetting: false,
        positionGoto: 0,
        autoRunAnimation: null,
        isSearchFilter: false,
        isAutoRunHotKey: false,
        typeAutoRunHotKey: null,
        hasChange: false,
        isShowIntro: {
          isLiked: false,
          isIgnore: false,
        },
        searchGuid: null,
        isLoading: false,
        isLoadingSearchUserName: false,
        isLoadingMore: false,
        isLoadingMoreSearchUserName: false,
        isShowExpandSearch: false,
        isHasMore: true,
        isHasMoreSearchUserName: true,
        userSearchSettings: {
          userName: '',
          onlineNow: false,
          withPhotos: false,
          isVerified: false,
          hasValidations: false,
        },
        memberViewIndex: null,
        memberViewProfile: null,
        isSwipingProfile: false,
        memberViewProfiles: {
          index: 0,
          indexActive: 0,
          histories: [],
        },
        memberInteraction: {
          isMatchAccepted: undefined,
          isLikedMutualMatch: false,
          isFavouritedMutualMatch: false,
          params: {
            Type: null,
          },
          user: undefined,
        },
        pageNumber: 1,
        pageSize: CONSTANTS.PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
        users: [],
        usersSearchUserName: [],
        popularNiches: undefined,
        travelDestinations: undefined,
        isShowHotKey: true,
        viewPropertyFilter: null,
        isOutOfLike: null,
        isShowProfileMatch: null,
        isShowInterested: null,
        lastQueryFilters: null,
        showMemberProfileId: null,
        filters: {
          userName: '',
          isCarouselView: false,
          location: null,
          isShowPremiumFilters: false,
          isShowLocationFilters: false,
          isSelectLocation: false,
          minAge: 18,
          maxAge: 99,
          searchRadius: CONSTANTS.REFINE_MODAL.PROXIMITY_DEFAULT_SHOW,
          onlineNow: false,
          withPhotos: false,
          hasValidations: false,
          isVerified: false,
          seekingMemberType: 25,
          niche: null,
          orderByType: [
            {
              id: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.MEMBER_LEVEL,
              key: 'featured',
              title: 'All',
              type: 'All',
              name: 'All',
              isCheck: false,
              value: 'MemberLevel',
              nameDesktop: 'Featured',
            },
            {
              id: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.MATCHING,
              key: 'matching',
              title: 'Matching',
              type: 'Matching',
              name: 'Matching',
              isCheck: true,
              value: 'Relevance',
              nameDesktop: 'Matching',
            },
            {
              id: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.NEWEST,
              key: 'newest',
              title: 'New',
              type: 'New',
              name: 'New',
              isCheck: false,
              value: 'NewMembers',
              nameDesktop: 'Newest',
            },
            {
              id: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.ACTIVE,
              key: 'recentlyActive',
              title: 'Active',
              type: 'Active',
              name: 'Active',
              isCheck: false,
              value: 'LastVisited',
              nameDesktop: 'Recently Active',
            },
            {
              id: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.SPOT_LIGHT,
              key: 'spotlight',
              title: 'Spotlight',
              type: 'Spotlight',
              name: 'Spotlight',
              isCheck: false,
              isDesktop: true,
              value: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE_VALUE.SPOT_LIGHT,
              nameDesktop: 'Spotlight',
            },
            {
              id: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.TRAVELLING,
              type: 'Traveling',
              isCheck: false,
              value: 'Traveling',
              isDesktop: true,
              nameDesktop: 'Travelling',
              key: 'traveling',
              title: 'Traveling',
              name: 'Traveling',
            },
            {
              id: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.NEAR_BY,
              key: 'nearBy',
              title: 'NearBy',
              type: 'NearBy',
              name: 'Nearby',
              isCheck: false,
              value: 'NearBy',
              nameDesktop: 'Nearby',
            },
            // {
            //     id: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.ACTIVE_NOW,
            //     key: 'activeNow',
            //     isCheck: false,
            //     value: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE_VALUE.ACTIVE_NOW,
            //     nameDesktop: 'ActiveNow',
            //     isDesktop: true,
            // },
          ],
        },
        isShowInternationalGuestModal: false,
        disableCheckVisa: false,
        showMeMemberType: new categoryModel({
          id: CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE,
        }),
        lookingFor: new categoryModel({ id: CATEGORY_ID.MS_LOOKING_FOR }),
        intentions: new categoryModel({ id: CATEGORY_ID.LTM_INTENTIONS }),
        maritalStatus: new categoryModel({ id: CATEGORY_ID.MARITAL_STATUS }),
        bodyTypes: new categoryModel({ id: CATEGORY_ID.TU2_BODY_TYPE }),
        height: new categoryModel({ id: CATEGORY_ID.TU2_HEIGHT }),
        ethnicity: new categoryModel({ id: CATEGORY_ID.TU1_ETHNICITY }),
        sexual: new categoryModel({ id: CATEGORY_ID.WYI_SEXUAL }),
        sexualInterests: new categoryModel({
          id: CATEGORY_ID.SEXUAL_INTERESTS,
        }),
        fetish: new categoryModel({ id: CATEGORY_ID.WYI_FETISH }),
        safeSex: new categoryModel({ id: CATEGORY_ID.SAFE_SEX }),
        endowment: new categoryModel({ id: CATEGORY_ID.ENDOWMENT }),
        participationLevel: new categoryModel({
          id: CATEGORY_ID.PARTICIPATION_LEVEL,
        }),
        isLoadInit: {
          lookingFor: false,
          showMeMemberType: false,
        },
        isGetData: false,
      };
      return state.merge({
        ...state,
        ...reset,
      });
      // console.log("log out membersearchreducer")
    }
    case types.RESET_FILTER_MEMBER_SEARCH: {
      const {
        filters,
        userSearchSettings,
        showMeMemberTypeDefault,
        lookingForDefault,
        intentionsDefault,
        maritalStatusDefault,
        bodyTypesDefault,
        heightDefault,
        ethnicityDefault,
        sexualDefault,
        sexualInterestsDefault,
        fetishDefault,
        safeSexDefault,
        endowmentDefault,
        participationLevelDefault,
        cupSizeDefault,
        smokingDefault,
        pubicHairDefault,
      } = Immutable.asMutable(state);

      const reset = {
        filters: {
          ...filters,
          ...userSearchSettings,
          orderByType: [
            {
              id: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.MEMBER_LEVEL,
              key: 'featured',
              title: 'All',
              type: 'All',
              name: 'All',
              isCheck: false,
              value: 'MemberLevel',
              nameDesktop: 'Featured',
            },
            {
              id: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.MATCHING,
              key: 'matching',
              title: 'Matching',
              type: 'Matching',
              name: 'Matching',
              isCheck: true,
              value: 'Relevance',
              nameDesktop: 'Matching',
            },
            {
              id: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.NEWEST,
              key: 'newest',
              title: 'New',
              type: 'New',
              name: 'New',
              isCheck: false,
              value: 'NewMembers',
              nameDesktop: 'Newest',
            },
            {
              id: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.ACTIVE,
              key: 'recentlyActive',
              title: 'Active',
              type: 'Active',
              name: 'Active',
              isCheck: false,
              value: 'LastVisited',
              nameDesktop: 'Recently Active',
            },
            {
              id: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.TRAVELLING,
              type: 'Traveling',
              isCheck: false,
              value: 'Traveling',
              isDesktop: true,
              nameDesktop: 'Travelling',
              key: 'traveling',
              title: 'Traveling',
              name: 'Traveling',
            },
            {
              id: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.NEAR_BY,
              key: 'nearBy',
              title: 'NearBy',
              type: 'NearBy',
              name: 'Nearby',
              isCheck: false,
              value: 'NearBy',
              nameDesktop: 'Nearby',
            },
            // {
            //     id: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.ACTIVE_NOW,
            //     key: 'activeNow',
            //     isCheck: false,
            //     value: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE_VALUE.ACTIVE_NOW,
            //     nameDesktop: 'ActiveNow',
            //     isDesktop: true,
            // },
          ],
          isShowPremiumFilters: false,
        },
        isShowInternationalGuestModal: false,
        disableCheckVisa: false,
        showMeMemberType: showMeMemberTypeDefault,
        lookingFor: lookingForDefault,
        intentions: intentionsDefault,
        maritalStatus: maritalStatusDefault,
        bodyTypes: bodyTypesDefault,
        height: heightDefault,
        ethnicity: ethnicityDefault,
        sexual: sexualDefault,
        sexualInterests: sexualInterestsDefault,
        fetish: fetishDefault,
        safeSex: safeSexDefault,
        endowment: endowmentDefault,
        participationLevel: participationLevelDefault,
        hasChange: false,
        isSearchFilter: false,
        isGetData: false,
        pubicHair: pubicHairDefault,
        smoking: smokingDefault,
        cupSize: cupSizeDefault,
      };
      return state.merge({
        ...reset,
      });
    }

    case types.RESET_PREMIUM_FILTER: {
      const {
        lookingForDefault,
        intentionsDefault,
        maritalStatusDefault,
        bodyTypesDefault,
        heightDefault,
        ethnicityDefault,
        sexualDefault,
        sexualInterestsDefault,
        fetishDefault,
        safeSexDefault,
        endowmentDefault,
        participationLevelDefault,
        cupSizeDefault,
        smokingDefault,
        pubicHairDefault,
      } = Immutable.asMutable(state);

      return state.merge({
        lookingFor: lookingForDefault,
        intentions: intentionsDefault,
        maritalStatus: maritalStatusDefault,
        bodyTypes: bodyTypesDefault,
        height: heightDefault,
        ethnicity: ethnicityDefault,
        sexual: sexualDefault,
        sexualInterests: sexualInterestsDefault,
        fetish: fetishDefault,
        safeSex: safeSexDefault,
        endowment: endowmentDefault,
        participationLevel: participationLevelDefault,
        cupSize: cupSizeDefault,
        smoking: smokingDefault,
        pubicHair: pubicHairDefault,
        hasChangePremiumFilters: false,
        indexSaveSelect: -1,
      });
    }

    case types.RESET_SEARCH_FILTER: {
      const { filters, userSearchSettings, showMeMemberTypeDefault } = Immutable.asMutable(state);
      return state.merge({
        filters: {
          ...filters,
          ...userSearchSettings,
          orderByType: [
            {
              id: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.MEMBER_LEVEL,
              key: 'featured',
              title: 'All',
              type: 'All',
              name: 'All',
              isCheck: false,
              value: 'MemberLevel',
              nameDesktop: 'Featured',
            },
            {
              id: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.MATCHING,
              key: 'matching',
              title: 'Matching',
              type: 'Matching',
              name: 'Matching',
              isCheck: true,
              value: 'Relevance',
              nameDesktop: 'Matching',
            },
            {
              id: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.NEWEST,
              key: 'newest',
              title: 'New',
              type: 'New',
              name: 'New',
              isCheck: false,
              value: 'NewMembers',
              nameDesktop: 'Newest',
            },
            {
              id: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.ACTIVE,
              key: 'recentlyActive',
              title: 'Active',
              type: 'Active',
              name: 'Active',
              isCheck: false,
              value: 'LastVisited',
              nameDesktop: 'Recently Active',
            },
            {
              id: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.SPOT_LIGHT,
              key: 'spotlight',
              title: 'Spotlight',
              type: 'Spotlight',
              name: 'Spotlight',
              isCheck: false,
              isDesktop: true,
              value: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE_VALUE.SPOT_LIGHT,
              nameDesktop: 'Spotlight',
            },
            {
              id: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.TRAVELLING,
              type: 'Traveling',
              isCheck: false,
              value: 'Traveling',
              isDesktop: true,
              nameDesktop: 'Travelling',
              key: 'traveling',
              title: 'Traveling',
              name: 'Traveling',
            },
            {
              id: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.NEAR_BY,
              key: 'nearBy',
              title: 'NearBy',
              type: 'NearBy',
              name: 'Nearby',
              isCheck: false,
              value: 'NearBy',
              nameDesktop: 'Nearby',
            },
            // {
            //   id: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.ACTIVE_NOW,
            //   key: 'activeNow',
            //   isCheck: false,
            //   value: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE_VALUE.ACTIVE_NOW,
            //   nameDesktop: 'ActiveNow',
            //   isDesktop: true,
            // },
          ],
          isShowPremiumFilters: false,
        },
        isShowInternationalGuestModal: false,
        disableCheckVisa: false,
        showMeMemberType: showMeMemberTypeDefault,
        hasChange: false,
        isSearchFilter: false,
        isGetData: false,
        indexSaveSelect: -1,
      });
    }
    case types.RESET_SEARCH_SPOTLIGHT_FILTER: {
      const { filtersSpotlight, userSearchSettings } = Immutable.asMutable(state);

      return state.merge({
        filtersSpotlight: {
          ...filtersSpotlight,
          ...userSearchSettings,
          showMeMemberType: {
            ...filtersSpotlight.showMeMemberTypeDefault,
          },
        },
        hasChangeSpotlight: false,
        isSearchFilter: false,
      });
    }
    case types.GET_USER_SAVED_SEARCHES_SUCCESS: {
      return state.merge({
        savedSearches: action.data,
      });
    }
    case types.DELETE_USER_MEMBER: {
      const { ids, isSpotlight } = action.data;
      let newUsers = state.users;
      let keys = 'users';
      if (isSpotlight) {
        newUsers = state.usersSpotlight;
        keys = 'usersSpotlight';
      }

      newUsers = newUsers.filter(user => !ids.includes(user.detail.userId));
      return state.setIn([keys], newUsers);
    }
    default:
      return state;
  }
}
